
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import SliderRoom from './partials/SliderRoom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from 'react-router-dom';
import Testimonials from './partials/Testimonials';

export default function RoomPage() {
  return (
    
    <>
    {/* <GlobalNavbar/> */}
{/* <div className="container"> */}

  <Helmet>
        <title> Rooms Near Delhi Airport | V Hotel The Grand Shoba</title>
        <meta
          name="description"
          content="Book comfortable rooms near Delhi Airport at V Hotel The Grand Shoba. Enjoy spacious stays, modern amenities, and warm hospitality just minutes from IGI Airport."
          />
        <meta name="keywords" content=" Rooms Near Delhi Airport" />
       
        <meta name="robots" content="index, follow" />
         <link rel="canonical" href="https://www.vhotelthegrandshoba.com/rooms" />

      </Helmet>

          <SliderRoom/>

       <div className="container">
           <div className="row">
            <h1 className='text-center' style={{color:"#856a2b", fontFamily:"Cinzel" , paddingTop:"20px",}}>Rooms Near Delhi Airport</h1>
             <div className="room-top-description mt-5">
             <p className='text-center ' style={{marginTop:"-45px"}}> Best Room Near Delhi Airport  - With 100 rooms and suites Shoba Hotel is designed to fulfill your every need and provide a truly luxurious and relaxing stay.
              Modern amenities and refined interiors create an atmosphere of comfort and elegance from the moment you step inside.
             </p>
             </div>
             
           </div>
       </div>

{/* -------------  desktop screen ------------------------- */}


       <div className="rooms-desktop-screen mb-5">
         <div className="row classic-container "> 
        
        {/*-----------------Classic room */}
        <Container className="my-4   " >
      <Row>
        <Col md={6}>
        <div className="product-container">
      
        


      <div className="main-image">
      <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img title="V Hotel The Grnad Shoba Classic Room"  loading='lazy' src="/images/room/classic/classicroom_.jpg"  className="d-block w-100 main-img"  alt="V-Hotel-the-Grand-shoba-clasic-room1"/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba Classic Room"  loading='lazy' src="/images/room/classic/Classic-Room_.jpg" className="d-block main-img" alt="V-Hotel-the-Grand-shoba-clasic-room2"/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba Classic Room"  loading='lazy' src="/images/room/classic/Classic_Room_.jpg" className="d-block main-img" alt="V-Hotel-the-Grand-shoba-clasic-room3"/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba Classic Room"  loading='lazy' src="/images/room/classic/roomwithsofa_.jpg" className="d-block main-img" alt="V-Hotel-the-Grand-shoba-clasic-room4"/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba Classic Room"  loading='lazy' src="/images/room/classic/wathroom_.jpg" className="d-block main-img" alt=" classic bathroom1"/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
     </div>
      </div>
       </div>
        </Col>

          
        <Col md={6} >
          <div className="classic-room-details  ">
          <h1  >Classic Room</h1>
          <p >The Classic Room offers comfort modern amenities and thoughtful essentials throughout your stay.</p>
          </div>

          <div className=" classic-room-service-main ">

           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba classic room  amenities"  src="/images/tea_icon_.svg" alt="V Hotel The Grnad Shoba classic room  Breakfast & tea free " />
              <p className="m-0"> Breakfast & tea</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba  classic room amenities"  loading='lazy' src="/images/pool_.svg" alt="V Hotel The Grnad Shoba  classic room Swimming Pool free " />
              <p className="m-0">Swimming Pool</p>
            </div>
           </div>
           <div className="classic-room-service classic-room-service-mob ">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba  classic room amenities"  loading='lazy' src="/images/pick_.svg" alt="V Hotel The Grnad Shoba classic room  Pick & Drop* free" />
              <p className="m-0">Pick & Drop*</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba  classic room amenities"  loading='lazy' src="/images/more-icon_.png" alt="V Hotel The Grnad Shoba classic room 10+ more amenities" />
              <p className="m-0">10 more amenities</p>
            </div>
           </div>

             <div className="row room-page-btn-main g-2">
                                 <div className="col-12 col-md-auto roompage-call-btn-main">
                                    <a title='v hotel the grand shoba phone' href='tel:+919874563210'> <button  className=" roompage-call-btn">Call Now</button></a>
                                 </div>
                                    <div className="col-12 col-md-auto ">
                                    <Link title='v hotel the grand shoba realted rooms' to="/related-room"  > <button  className="roompage-query-btn">BOOK NOW</button></Link>
                                    </div>
                                </div>
          </div>
        </Col>
      </Row>
        </Container>

{/* ------------------------Executive Room  */}

    <Container className="my-5 px-2 ">
      <Row>
      <Col md={6}>
          <div className="classic-room-details">
          <h1 >Executive Room</h1>
          <p >Experience the Elegance of Space, Style, and Serenity – All in One Executive Retreat</p>
          </div>

          <div className="mt-3 classic-room-service-main">
           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba Executive Room amenities"  src="/images/tea_icon_.svg" alt="V Hotel The Grnad Shoba Executive Room breakfast and tea free" />
              <p className="m-0"> Breakfast & tea</p>
            </div>


            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba Executive Room amenities"  loading='lazy' src="/images/pool_.svg" alt="V Hotel The Grnad Shoba Executive Room swimming pool free" />
              <p className="m-0">Swimming Pool</p>
            </div>
           </div>
           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba Executive Room amenities"  loading='lazy' src="/images/pick_.svg" alt="V Hotel The Grnad Shoba Executive Room pick and drop free" />
              <p className="m-0">Pick & Drop*</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba Executive Room amenities "  loading='lazy' src="/images/more-icon_.png" alt="V Hotel The Grnad Shoba Executive Room 10+ more amenities" />
              <p className="m-0">10 more amenities</p>
            </div>
           </div>

         
             <div className="row room-page-btn-main g-2">
                                 <div className="col-12 col-md-auto roompage-call-btn-main">
                                    <a title='v hotel the grand shoba phone' href='tel:+919874563210'> <button  className=" roompage-call-btn">Call Now</button></a>
                                 </div>
                                    <div className="col-12 col-md-auto ">
                                    <Link title='v hotel the grand shoba related rooms' to="/related-room"> <button  className="roompage-query-btn">BOOK NOW</button></Link>
                                    </div>
                                </div>
          </div>
        </Col>


        <Col md={6}>
        <div className="product-container">
   
      {/* <div className="main-image-delux">
        <img title="V Hotel The Grnad Shoba RoomImageTitle"  src={""} alt="Current Preview" className="main-img" />
      </div> */}

<div id="carouselExampleIndicators" className="carousel slide">
  
  <div className="carousel-inner">
  <div className="carousel-item active">
      <img title="V Hotel The Grnad Shoba executive rooms "  loading='lazy' src="/images/room/executive/room1_.JPG" className="d-block main-img" alt="V Hotel The Grnad Shoba executive rooms"/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba executive rooms "  loading='lazy' src="/images/room/executive/room3_.JPG" className="d-block main-img" alt="V Hotel The Grnad Shoba executive rooms"/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba executive rooms "  loading='lazy' src="/images/room/executive/room2_.JPG" className="d-block main-img" alt="V Hotel The Grnad Shoba executive rooms"/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba executive rooms "  loading='lazy' src="/images/room/executive/room4_.JPG" className="d-block main-img" alt="V Hotel The Grnad Shoba executive rooms"/>
    </div>
     <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba executive rooms "  loading='lazy' src="/images/room/executive/Suite-Room-washroom_.jpg" className="d-block main-img" alt="V Hotel The Grnad Shoba executive rooms"/>
    </div>
    
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>

       </div>
        </Col>

        
      </Row>
        </Container>

       {/* ------------------------Deluxe  Room  */}
       <Container className="my-5 mx-4">
      <Row>
      <Col md={6}>
        <div className="product-container">
     
      <div className="main-image">
<div id="carouselExampleCaptions" className="carousel slide">
  
  <div className="carousel-inner">
   
    <div className="carousel-item active">
      <img title="V Hotel The Grnad Shoba deluxe rooms"  loading='lazy' src="/images/room/deluxe/deluxe_room_.jpg" className="d-block main-img" alt="V-Hotel-the-Grand-shoba-deluxe room"/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba deluxe rooms"  loading='lazy' src="/images/room/deluxe/deluxe_side_view_.jpg" className="d-block main-img" alt="V-Hotel-the-Grand-shoba-deluxe room"/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba deluxe rooms"  loading='lazy' src="/images/room/deluxe/deluxe-room_.jpg" className="d-block main-img" alt="V-Hotel-the-Grand-shoba-deluxe room"/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba deluxe rooms"  loading='lazy' src="/images/room/deluxe/washroom_.jpg" className="d-block main-img" alt="V-Hotel-the-Grand-shoba-deluxe room"/>
      
    </div>

  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
      </div>

       </div>
        </Col>

        <Col md={6}>
          <div className="classic-room-details">
          <h1 > Deluxe Room</h1>
          <p >Experience the Elegance of Space, Style, and Serenity – All in One Deluxe Retreat.</p>
          </div>

          <div className="mt-3 classic-room-service-main">
           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba deluxe room amenities"  src="/images/tea_icon_.svg" alt="V Hotel The Grnad Shoba deluxe room breakfast & tea free " />
              <p className="m-0"> Breakfast & tea</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba deluxe room amenities"  loading='lazy' src="/images/pool_.svg" alt="V Hotel The Grnad Shoba deluxe room swimming pool free" />
              <p className="m-0">Swimming Pool</p>
            </div>
           </div>
           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba deluxe room amenities"  loading='lazy' src="/images/pick_.svg" alt="V Hotel The Grnad Shoba deluxe room pick and drop free" />
              <p className="m-0">Pick & Drop*</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba deluxe room amenities"  loading='lazy' src="/images/more-icon_.png" alt="V Hotel The Grnad Shoba deluxe room 10+ amenities" />
              <p className="m-0">10 more amenities</p>
            </div>
           </div>

            {/* <div className="btn-box mt-3">
             <a href='tel:+919874563210'> <button variant="primary" className='clssic-button '>Call Now</button></a>
             <Link to="/booking"> <button variant="outline-secondary " className='clssic-button1 ' >BOOK NOW</button> </Link>
            </div> */}
             <div className="row room-page-btn-main g-2">
                                 <div className="col-12 col-md-auto roompage-call-btn-main">
                                    <a title='v hotel the grand shoba phone' href='tel:+919874563210'> <button  className=" roompage-call-btn">Call Now</button></a>
                                 </div>
                                    <div className="col-12 col-md-auto ">
                                    <Link  title='v hotel the grand shoba related rooms' to="/related-room"> <button  className="roompage-query-btn">BOOK NOW</button></Link>
                                    </div>
                                </div>
          </div>
        </Col>
      </Row>
        </Container>




{/* ------------------------Super deluxe Room  */}

<Container className="my-5 px-4">
      <Row>
      <Col md={6}>
          <div className="classic-room-details">
          <h1 > Super Deluxe Room</h1>
          <p >More Than Just a Room  A Bespoke Experience of Rest, Elegance, and Impeccable Service.</p>
          </div>

          <div className="mt-3 classic-room-service-main">
           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba super-deluxe room amenities"  src="/images/tea_icon_.svg" alt="V Hotel The Grnad Shoba  super deluxe room breakfast and tea free" />
              <p className="m-0"> Breakfast & tea</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba super-deluxe room amenities"  loading='lazy' src="/images/pool_.svg" alt="V Hotel The Grnad Shoba super deluxe room pool free " />
              <p className="m-0">Swimming Pool</p>
            </div>
           </div>
           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba super-deluxe room amenities"  loading='lazy' src="/images/pick_.svg" alt="V Hotel The Grnad Shoba  super-deluxe room pick and drop free" />
              <p className="m-0">Pick & Drop*</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba super-deluxe room amenities"  loading='lazy' src="/images/more-icon_.png" alt="V Hotel The Grnad Shoba super-deluxe room 10 more amenities" />
              <p className="m-0">10 more amenities</p>
            </div>
           </div>

            {/* <div className="btn-box mt-3">
             <a href='tel:+919874563210'> <button variant="primary" className='clssic-button '>Call Now</button></a>
             <Link to="/booking"> <button variant="outline-secondary " className='clssic-button1 ' >BOOK NOW</button> </Link>
            </div> */}
             <div className="row room-page-btn-main g-2">
                                 <div className="col-12 col-md-auto roompage-call-btn-main">
                                    <a title='v hotel the grand shoba phone' href='tel:+919874563210'> <button  className=" roompage-call-btn">Call Now</button></a>
                                 </div>
                                    <div className="col-12 col-md-auto ">
                                    <Link title='v hotel the grand shoba related rooms' to="/related-room"> <button  className="roompage-query-btn">BOOK NOW</button></Link>
                                    </div>
                                </div>
          </div>
        </Col>


        <Col md={6}>
        <div className="product-container">
      {/* <div className="thumbnails">
        {images.map((img, idx) => (
          <img
            key={idx}
            src={img}
            alt={`Thumbnail ${idx + 1}`}
            className={`thumb-img ${currentImage === img ? 'active-thumb' : ''}`}
            onMouseEnter={() => handleHover(img, idx)}
          />
        ))}
      </div> */}

      {/* <div className="main-image">
        <img title="V Hotel The Grnad Shoba RoomImageTitle"  src={""} alt="Current Preview" className="main-img" />
      </div> */}

<div id="carouselExampleFade" className="carousel slide carousel-fade">
  <div className="carousel-inner">
  

    <div className="carousel-item active">
      <img title="V Hotel The Grnad Shoba super deluxe room"  loading='lazy' src="/images/room/superdeluxe/super-deluxe-room2_.jpg" className="d-block main-img" alt="V Hotel The Grnad Shoba super-deluxe "/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba super deluxe room"  loading='lazy' src="/images/room/superdeluxe/super-deluxe-room6_.jpg" className="d-block main-img" alt="V Hotel The Grnad Shoba super-deluxe "/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba super deluxe room"  loading='lazy' src="/images/room/superdeluxe/super-deluxe-room7_.jpg" className="d-block main-img" alt="V Hotel The Grnad Shoba super-deluxe "/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba super deluxe room"  loading='lazy' src="/images/room/superdeluxe/super-deluxe-room3_.jpg" className="d-block main-img" alt="V Hotel The Grnad Shoba super-deluxe "/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba super deluxe room"  loading='lazy' src="/images/room/superdeluxe/super-deluxe-room5_.jpg" className="d-block main-img" alt="V Hotel The Grnad Shoba super-deluxe "/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba super deluxe room"  loading='lazy' src="/images/room/superdeluxe/washroom_.jpg" className="d-block main-img" alt="V Hotel The Grnad Shoba super-deluxe "/>
    </div>


  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
       </div>
        </Col>

        
      </Row>
        </Container>


{/*-----------------suite room */}
<Container className="my-4 mx-4">
      <Row>
      <Col md={6}>
        <div className="product-container ">
     

      <div className="main-image">
    
         <div id="carouselExampleRide" className="carousel slide" data-bs-ride="true">
  <div className="carousel-inner">
    <div className="carousel-item active">
    <img title="V Hotel The Grnad Shoba suite room "  loading='lazy' src="/images/room/suite/Suite-Room-1_.jpg" className="d-block main-img" alt="V-Hotel-the-Grand-shoba-Suite-room1"/>
    </div>
    <div className="carousel-item">
    <img title="V Hotel The Grnad Shoba suite room "  loading='lazy' src="/images/room/suite/Suite-Room-2_.jpg" className="d-block main-img" alt="V-Hotel-the-Grand-shoba-Suite-room1"/>
    </div>
    <div className="carousel-item">
    <img title="V Hotel The Grnad Shoba suite room "  loading='lazy' src="/images/room/suite/Suite-Room-3_.jpg" className="d-block main-img" alt="V-Hotel-the-Grand-shoba-Suite-room1"/>

    </div>
    <div className="carousel-item">
    <img title="V Hotel The Grnad Shoba suite room "  loading='lazy' src="/images/room/suite/Suite-Room-4_.jpg" className="d-block main-img" alt="V-Hotel-the-Grand-shoba-Suite-room1"/>
    </div>
    <div className="carousel-item">
    <img title="V Hotel The Grnad Shoba suite room "  loading='lazy' src="/images/room/suite/room-in_.jpg" className="d-block main-img" alt="V-Hotel-the-Grand-shoba-Suite-room1"/>
    </div>
    <div className="carousel-item">
    <img title="V Hotel The Grnad Shoba suite room "  loading='lazy' src="/images/room/suite/Suite-Room-washroom_.jpg" className="d-block main-img" alt="V-Hotel-the-Grand-shoba-Suite-room1"/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleRide" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleRide" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
           </div>
      </div>
       </div>
        </Col> 

        <Col md={6}>
          <div className="classic-room-details">
          <h1 >Suite Room</h1>
          <p >A Suite That Redefines Living Thoughtfully Designed for Moments That Matter.</p>
          </div>

          <div className="mt-3 classic-room-service-main">

           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba suite room amenities"  src="/images/tea_icon_.svg" alt="V Hotel The Grnad Shoba suite room breakfast and tea free  " />
              <p className="m-0"> Breakfast & tea</p>
            </div>

            
            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba suite room amenities"  loading='lazy' src="/images/pool_.svg" alt="V Hotel The Grnad Shoba suite room swimming pool free " />
              <p className="m-0">Swimming Pool</p>
            </div>
           </div>
           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba suite room amenities"  loading='lazy' src="/images/pick_.svg" alt="iV Hotel The Grnad Shoba suite room pick and drop free " />
              <p className="m-0">Pick & Drop*</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba suite room amenities"  loading='lazy' src="/images/more-icon_.png" alt="V Hotel The Grnad Shoba 10+ amenities " />
              <p className="m-0">10 more amenities</p>
            </div>
           </div>

           
             <div className="row room-page-btn-main g-2">
                                 <div className="col-12 col-md-auto roompage-call-btn-main">
                                    <a  title='v hotel the grand shoba phone' href='tel:+919874563210'> <button  className=" roompage-call-btn">Call Now</button></a>
                                 </div>
                                    <div className="col-12 col-md-auto ">
                                    <Link  title='v hotel the grand shoba related rooms'to="/related-room"> <button  className="roompage-query-btn">BOOK NOW</button></Link>
                                    </div>
                                </div>
          </div>
        </Col>
      </Row>
        </Container>


<Container className="my-5 px-4">
      <Row>
      <Col md={6}>
          <div className="classic-room-details">
          <h1 > Family Suite  Room</h1>
          <p >The Family Suite — Generously Appointed for Comfort, Connection, and Convenience.</p>
          </div>

          <div className="mt-3 classic-room-service-main">
           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba family suite room amenities "  src="/images/tea_icon_.svg" alt="V Hotel The Grnad Shoba family suite room breakfast and tea free" />
              <p className="m-0"> Breakfast & tea</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba family suite room amenities "  loading='lazy' src="/images/pool_.svg" alt="V Hotel The Grnad Shoba family suite room swimming poll free" />
              <p className="m-0">Swimming Pool</p>
            </div>
           </div>
           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba family suite room amenities "  loading='lazy' src="/images/pick_.svg" alt="V Hotel The Grnad Shoba family suite room pick and drop free" />
              <p className="m-0">Pick & Drop*</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba family suite room amenities "  loading='lazy' src="/images/more-icon_.png" alt="V Hotel The Grnad Shoba family suite room 10+ amenities" />
              <p className="m-0">10 more amenities</p>
            </div>
           </div>

     
             <div className="row room-page-btn-main g-2">
                                 <div className="col-12 col-md-auto roompage-call-btn-main">
                                    <a title='v hotel the grand shoba phone' href='tel:+919874563210'> <button  className=" roompage-call-btn">Call Now</button></a>
                                 </div>
                                    <div className="col-12 col-md-auto ">
                                    <Link title='v hotel the grand shoba related rooms' to="/related-room"> <button  className="roompage-query-btn">BOOK NOW</button></Link>
                                    </div>
                                </div>
          </div>
        </Col>


        <Col md={6}>
        <div className="product-container">
  

<div id="carousel2" className="carousel slide mb-5">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img title="V Hotel The Grnad Shoba family suite room "  loading='lazy' src="/images/room/familysuite/ROOMS-5_.jpg" className="d-block main-img" alt="V Hotel The Grnad Shoba family suite room "/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba family suite room "  loading='lazy' src="/images/room/superdeluxe/washroom_.jpg" className="d-block main-img" alt="V Hotel The Grnad Shoba family suite room"/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba family suite room "  loading='lazy' src="/images/room/familysuite/ROOMS-5-3_.jpg" className="d-block main-img" alt="V Hotel The Grnad Shoba family suite room"/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba family suite room "  loading='lazy' src="/images/room/familysuite/ROOMS-5-4_.jpg" className="d-block main-img" alt="V Hotel The Grnad Shoba family suite room"/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carousel2" data-bs-slide="prev">
    <span className="carousel-control-prev-icon"></span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carousel2" data-bs-slide="next">
    <span className="carousel-control-next-icon"></span>
  </button>
</div>
       </div>
        </Col>

        
      </Row>
        </Container>

        
        </div>

    </div>


  {/* ------------------- Moblie screen -------------------- */}
  <div className="rooms-mobile-screen mb-5">
  <div className="row classic-container "> 
        <Container className="my-4   " >
      <Row>
        <Col md={6}>
        <div className="product-container">
      

      <div className="main-image">
      <div id="carouselDeluxe" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
           <img title="V Hotel The Grnad Shoba classic room "  loading='lazy' src="/images/room/classic/room_.jpg" className="d-block w-100 "  alt="V Hotel The Grnad Shoba classic room"/>
    </div>
    <div className="carousel-item">
           <img title="V Hotel The Grnad Shoba classic room "  loading='lazy' src="/images/room/classic/Classic_Room_.jpg" className="d-block " alt="V Hotel The Grnad Shoba family suite room "/>
    </div>
    <div className="carousel-item active">
            <img title="V Hotel The Grnad Shoba classic room "  loading='lazy' src="/images/room/classic/Classic-Room_.jpg" className="d-block " alt="V Hotel The Grnad Shoba family suite room "/>
    </div>
    <div className="carousel-item active">
           <img title="V Hotel The Grnad Shoba classic room "  loading='lazy' src="/images/room/classic/roomwithsofa_.jpg" className="d-block " alt="V Hotel The Grnad Shoba family suite room "/>
    </div>
    <div className="carousel-item active">
          <img title="V Hotel The Grnad Shoba classic room "  loading='lazy' src="/images/room/classic/wathroom_.jpg" className="d-block " alt=" V Hotel The Grnad Shoba family suite room amenities"/>
    </div>

  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselDeluxe" data-bs-slide="prev">
    <span className="carousel-control-prev-icon"></span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselDeluxe" data-bs-slide="next">
    <span className="carousel-control-next-icon"></span>
  </button>
</div>
      </div>
       </div>
        </Col>

        <Col md={6} >
          <div className="classic-room-details ">
          <h4 >Classic Room</h4>
          <p >The Classic Room offers comfort modern amenities and thoughtful essentials throughout your stay.</p>
          </div>

          <div className=" classic-room-service-main ">

           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba classic room amenities"  src="/images/tea_icon_.svg" alt="V Hotel The Grnad Shoba classic room breakfast and tea free" />
              <p className="m-0"> Breakfast & tea</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba classic room amenities"  loading='lazy' src="/images/pool_.svg" alt="V Hotel The Grnad Shoba classic room swimming poll fee" />
              <p className="m-0">Swimming Pool</p>
            </div>
           </div>
           <div className="classic-room-service classic-room-service-mob ">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba classic room amenities"  loading='lazy' src="/images/pick_.svg" alt="V Hotel The Grnad Shoba classic room pick and drop free" />
              <p className="m-0">Pick & Drop*</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba classic room amenities"  loading='lazy' src="/images/more-icon_.png" alt="V Hotel The Grnad Shoba classic room 10+  amenities" />
              <p className="m-0">10 more amenities</p>
            </div>
           </div>

             <div className="row g-2">
                     <div className="col-12 col-md-auto roompage-call-btn-main">
                        <a title='v hotel the grand shoba phone' href='tel:+919874563210'> <button  className=" roompage-call-btn">Call Now</button></a>
                     </div>
                        <div className="col-12 col-md-auto roompage-call-btn-main">
                        <Link  title='v hotel the grand shoba related rooms' to="/related-room"> <button  className="roompage-query-btn">BOOK NOW</button></Link>
                        </div>
                    </div>
          </div>
        </Col>
      </Row>
        </Container>



<Container className="my-4  ">
      <Row>
        <Col md={6}>
        <div className="product-container">
     

      <div className="main-image">
      <div id="carouselSuite2" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    
    <div className="carousel-item active">
      <img title="V Hotel The Grnad Shoba executive room "  loading='lazy' src="/images/room/executive/room1_.JPG" alt='V Hotel The Grnad Shoba Executive-room-1' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba executive room "  loading='lazy' src="/images/room/executive/room3_.JPG" alt='V Hotel The Grnad Shoba Executive-room-2' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba executive room "  loading='lazy' src="/images/room/executive/room2_.JPG" alt='V Hotel The Grnad Shoba Executive-room-3' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba executive room "  loading='lazy' src="/images/room/executive/room4_.JPG" alt='V Hotel The Grnad Shoba Executive-room-4' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba executive room "  loading='lazy' src="/images/room/deluxe/washroom_.jpg" alt='V Hotel The Grnad Shoba Executive-room-5' className="d-block w-100" />
    </div>


  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselSuite2" data-bs-slide="prev">
    <span className="carousel-control-prev-icon"></span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselSuite2" data-bs-slide="next">
    <span className="carousel-control-next-icon"></span>
  </button>
</div>

      </div>
       </div>
        </Col>

        <Col md={6} >
          <div className="classic-room-details ">
          <h4 >Executive Room</h4>
          <p >More Than Just a Room – A Bespoke Experience of Rest, Elegance, and Impeccable Service.</p>
          </div>

          <div className=" classic-room-service-main ">

           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba executive room amenities"  src="/images/tea_icon_.svg" alt="V Hotel The Grnad Shoba executive room breakfast and tea free" />
              <p className="m-0"> Breakfast & tea</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba executive room amenities"  loading='lazy' src="/images/pool_.svg" alt="V Hotel The Grnad Shoba executive room  swimming pool free" />
              <p className="m-0">Swimming Pool</p>
            </div>
           </div>
           <div className="classic-room-service classic-room-service-mob ">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba executive room amenities"  loading='lazy' src="/images/pick_.svg" alt="V Hotel The Grnad Shoba executive room pick and drop free" />
              <p className="m-0">Pick & Drop*</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba executive room amenities"  loading='lazy' src="/images/more-icon_.png" alt="V Hotel The Grnad Shoba executive room 10+ amenitie" />
              <p className="m-0">10 more amenities</p>
            </div>
           </div>

             <div className="row g-2">
                     <div className="col-12 col-md-auto roompage-call-btn-main">
                        <a title='v hotel the grand shoba phone' href='tel:+919874563210'> <button  className=" roompage-call-btn">Call Now</button></a>
                     </div>
                        <div className="col-12 col-md-auto">
                        <Link title='v hotel the grand shoba related rooms' to="/related-room"> <button  className="roompage-query-btn">BOOK NOW</button></Link>
                        </div>
                    </div>
          </div>
        </Col>
      </Row>
        </Container>





       <Container className="my-4  ">
      <Row>
        <Col md={6}>
        <div className="product-container">
    

      <div className="main-image">
      <div id="carouselSuite" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
           <img title="V Hotel The Grnad Shoba deluxe room "  loading='lazy' src="/images/room/deluxe/deluxe_room_.jpg" className="d-block " alt="V Hotel The Grnad Shoba deluxe room"/>

    </div>
    <div className="carousel-item">
            <img title="V Hotel The Grnad Shoba deluxe room "  loading='lazy' src="/images/room/deluxe/deluxe_.jpg" className="d-block main-img" alt="V Hotel The Grnad Shoba deluxe room "/>
    </div>
    <div className="carousel-item">
            <img title="V Hotel The Grnad Shoba deluxe room "  loading='lazy' src="/images/room/deluxe/deluxe_side_view_.jpg" className="d-block main-img" alt="V Hotel The Grnad Shoba deluxe room "/>
    </div>
    <div className="carousel-item">
           <img title="V Hotel The Grnad Shoba deluxe room "  loading='lazy' src="/images/room/deluxe/deluxe-room_.jpg" className="d-block main-img" alt="V Hotel The Grnad Shoba deluxe room "/>
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba deluxe room "  loading='lazy' src="/images/room/deluxe/washroom_.jpg" className="d-block " alt="V Hotel The Grnad Shoba deluxe room "/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselSuite" data-bs-slide="prev">
    <span className="carousel-control-prev-icon"></span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselSuite" data-bs-slide="next">
    <span className="carousel-control-next-icon"></span>
  </button>
</div>
      </div>
       </div>
        </Col>

        <Col md={6} >
          <div className="classic-room-details ">
          <h4 >Deluxe Room</h4>
          <p >Experience the Elegance of Space, Style, and Serenity – All in One Deluxe Retreat.</p>
          </div>

          <div className=" classic-room-service-main ">

           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba deluxe room amenities "  src="/images/tea_icon_.svg" alt="V Hotel The Grnad Shoba deluxe room breakfast and tea free" />
              <p className="m-0"> Breakfast & tea</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba deluxe room amenities "  loading='lazy' src="/images/pool_.svg" alt="V Hotel The Grnad Shoba deluxe room swimming pool free" />
              <p className="m-0">Swimming Pool</p>
            </div>
           </div>
           <div className="classic-room-service classic-room-service-mob ">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba deluxe room amenities "  loading='lazy' src="/images/pick_.svg" alt="V Hotel The Grnad Shoba deluxe room pick and drop free" />
              <p className="m-0">Pick & Drop*</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba deluxe room amenities "  loading='lazy' src="/images/more-icon_.png" alt="V Hotel The Grnad Shoba  deluxe room 10+ amenities" />
              <p className="m-0">10 more amenities</p>
            </div>
           </div>

             <div className="row g-2">
                     <div className="col-12 col-md-auto roompage-call-btn-main">
                        <a title='v hotel the grand shoba phone' href='tel:+919874563210'> <button  className=" roompage-call-btn">Call Now</button></a>
                     </div>
                        <div className="col-12 col-md-auto">
                        <Link  title='v hotel the grand shoba related rooms' to="/related-room"> <button  className="roompage-query-btn">BOOK NOW</button></Link>
                        </div>
                    </div>
          </div>
        </Col>
      </Row>
        </Container>

<Container className="my-4  ">
      <Row>
        <Col md={6}>
        <div className="product-container">
     

      <div className="main-image">
      <div id="carouselSuite1" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    
    <div className="carousel-item active">
      <img title="V Hotel The Grnad Shoba super deluxe room "  loading='lazy' src="/images/room/superdeluxe/super-deluxe-room2_.jpg" alt='V Hotel The Grnad Shoba super-deluxe-1' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba super deluxe room "  loading='lazy' src="/images/room/superdeluxe/super-deluxe-room6_.jpg" alt='V Hotel The Grnad Shoba super-deluxe-2' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba super deluxe room "  loading='lazy' src="/images/room/superdeluxe/super-deluxe-room7_.jpg" alt='V Hotel The Grnad Shoba super-deluxe-3' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba super deluxe room "  loading='lazy' src="/images/room/superdeluxe/super-deluxe-room3_.jpg" alt='V Hotel The Grnad Shoba super-deluxe-4' className="d-block w-100" />
    </div>
<div className="carousel-item">
      <img title="V Hotel The Grnad Shoba super deluxe room "  loading='lazy' src="/images/room/superdeluxe/super-deluxe-room5_.jpg" alt='V Hotel The Grnad Shoba super-deluxe-6' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba super deluxe room "  loading='lazy' src="/images/room/superdeluxe/washroom_.jpg" alt='V Hotel The Grnad Shoba super-deluxe-7' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba super deluxe room "  loading='lazy' src="/images/room/superdeluxe/room-last_.jpg" alt='V Hotel The Grnad Shoba super-deluxe-8' className="d-block w-100" />
    </div>

  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselSuite1" data-bs-slide="prev">
    <span className="carousel-control-prev-icon"></span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselSuite1" data-bs-slide="next">
    <span className="carousel-control-next-icon"></span>
  </button>
       </div>
      </div>
       </div>
        </Col>

        <Col md={6} >
          <div className="classic-room-details ">
          <h4 >Super Deluxe Room</h4>
          <p >More Than Just a Room – A Bespoke Experience of Rest, Elegance, and Impeccable Service.</p>
          </div>

          <div className=" classic-room-service-main ">

           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba super deluxe room amenities "  src="/images/tea_icon_.svg" alt="V Hotel The Grnad Shoba super deluxe room breakfast and tea free" />
              <p className="m-0"> Breakfast & tea</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba super deluxe room amenities "  loading='lazy' src="/images/pool_.svg" alt="V Hotel The Grnad Shoba super deluxe room swimming pool free  " />
              <p className="m-0">Swimming Pool</p>
            </div>
           </div>
           <div className="classic-room-service classic-room-service-mob ">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba super deluxe room amenities "  loading='lazy' src="/images/pick_.svg" alt="V Hotel The Grnad Shoba  super deluxe room pick and drop free" />
              <p className="m-0">Pick & Drop*</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba super deluxe room amenities "  loading='lazy' src="/images/more-icon_.png" alt="V Hotel The Grnad Shoba super deluxe room  10+ amenities  " />
              <p className="m-0">10 more amenities</p>
            </div>
           </div>

             <div className="row g-2">
                     <div className="col-12 col-md-auto roompage-call-btn-main">
                        <a title='v hotel the grand shoba phone' href='tel:+919874563210'> <button  className=" roompage-call-btn">Call Now</button></a>
                     </div>
                        <div className="col-12 col-md-auto">
                        <Link title='v hotel the grand shoba related rooms' to="/related-room"> <button  className="roompage-query-btn">BOOK NOW</button></Link>
                        </div>
                    </div>
          </div>
        </Col>
      </Row>
        </Container>

        <Container className="my-4  ">
      <Row>
        <Col md={6}>
        <div className="product-container">
     

      <div className="main-image">
      <div id="carouselSuite10" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img title="V Hotel The Grnad Shoba suite room "  loading='lazy' src="/images/room/suite/Suite-Room-1_.jpg" alt='V Hotel The Grnad Shoba suite-room1' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba suite room "  loading='lazy' src="/images/room/suite/Suite-Room-2_.jpg" alt='V Hotel The Grnad Shoba suite-room2' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba suite room "  loading='lazy' src="/images/room/suite/Suite-Room-3_.jpg" alt='V Hotel The Grnad Shoba suite-room3' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba suite room "  loading='lazy' src="/images/room/suite/Suite-Room-4_.jpg" alt='V Hotel The Grnad Shoba suite-room4' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba suite room "  loading='lazy' src="/images/room/suite/room-in_.jpg" alt='V Hotel The Grnad Shoba suite-room4' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba suite room "  loading='lazy' src="/images/room/suite/Suite-Room-washroom_.jpg" alt='V Hotel The Grnad Shoba suite-room4' className="d-block w-100" />
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselSuite10" data-bs-slide="prev">
    <span className="carousel-control-prev-icon"></span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselSuite10" data-bs-slide="next">
    <span className="carousel-control-next-icon"></span>
  </button>
</div>
      </div>
       </div>
        </Col>

        <Col md={6} >
          <div className="classic-room-details ">
          <h4 >Suite Room</h4>
          <p >A Suite That Redefines Living — Thoughtfully Designed for Moments That Matter.</p>
          </div>

          <div className=" classic-room-service-main ">

           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba suite room amenities "  src="/images/tea_icon_.svg" alt="V Hotel The Grnad Shoba suite room breakfast and tea free" />
              <p className="m-0"> Breakfast & tea</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba suite room amenities "  loading='lazy' src="/images/pool_.svg" alt="V Hotel The Grnad Shoba  suite room swimming pool free" />
              <p className="m-0">Swimming Pool</p>
            </div>
           </div>
           <div className="classic-room-service classic-room-service-mob ">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba suite room amenities "  loading='lazy' src="/images/pick_.svg" alt="V Hotel The Grnad Shoba suite room pick and drop free" />
              <p className="m-0">Pick & Drop*</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba suite room amenities "  loading='lazy' src="/images/more-icon_.png" alt="V Hotel The Grnad Shoba suite room 10+ amenitie" />
              <p className="m-0">10 more amenities</p>
            </div>
           </div>

             <div className="row g-2">
                     <div className="col-12 col-md-auto roompage-call-btn-main">
                        <a title='v hotel the grand shoba phone' href='tel:+919874563210'> <button  className=" roompage-call-btn">Call Now</button></a>
                     </div>
                        <div className="col-12 col-md-auto">
                        <Link title='v hotel the grand shoba related rooms' to="/related-room"> <button  className="roompage-query-btn">BOOK NOW</button></Link>
                        </div>
                    </div>
          </div>
        </Col>
      </Row>
        </Container>

        <Container className="my-4  ">
      <Row>
        <Col md={6}>
        <div className="product-container">
     

      <div className="main-image">
      <div id="carouselSuite3" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img title="V Hotel The Grnad Shoba family-suite room "  loading='lazy' src="/images/room/familysuite/ROOMS-5_.jpg" alt='V Hotel The Grnad Shoba family-suite1' className="d-block w-100 main-img" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba family-suite room "  loading='lazy' src="/images/room/superdeluxe/washroom_.jpg" alt='V Hotel The Grnad Shoba family-suite2' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba family-suite room "  loading='lazy' src="/images/room/familysuite/ROOMS-5-3_.jpg" alt='V Hotel The Grnad Shoba family-suite3' className="d-block w-100" />
    </div>
    <div className="carousel-item">
      <img title="V Hotel The Grnad Shoba family-suite room "  loading='lazy' src="/images/room/familysuite/ROOMS-5-4_.jpg" alt='V Hotel The Grnad Shoba family-suite4' className="d-block w-100" />
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselSuite3" data-bs-slide="prev">
    <span className="carousel-control-prev-icon"></span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselSuite3" data-bs-slide="next">
    <span className="carousel-control-next-icon"></span>
  </button>
</div>
      
      </div>
       </div>
        </Col>

        <Col md={6} >
          <div className="classic-room-details ">
          <h4 >Family Suite  Room</h4>
          <p >The Family Suite — Generously Appointed for Comfort, Connection, and Convenience.</p>
          </div>

          <div className=" classic-room-service-main ">

           <div className="classic-room-service">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba family suite "  src="/images/tea_icon_.svg" alt="V Hotel The Grnad Shoba family suite room breakfast and tea free" />
              <p className="m-0"> Breakfast & tea</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba family suite "  loading='lazy' src="/images/pool_.svg" alt="V Hotel The Grnad Shoba family suite swimming pool free" />
              <p className="m-0">Swimming Pool</p>
            </div>
           </div>
           <div className="classic-room-service classic-room-service-mob ">
           <div className="small-box">
              <img title="V Hotel The Grnad Shoba family suite "  loading='lazy' src="/images/pick_.svg" alt="V Hotel The Grnad Shoba family suite room pick and drop free" />
              <p className="m-0">Pick & Drop*</p>
            </div>

            <div className="small-box1">
              <img title="V Hotel The Grnad Shoba family suite "  loading='lazy' src="/images/more-icon_.png" alt="V Hotel The Grnad Shoba family suite room 10+ amenities " />
              <p className="m-0">10 more amenities</p>
            </div>
           </div>

        
            <div className="row  g-2">
                                 <div className="col-12 col-md-auto roompage-call-btn-main">
                                    <a title='v hotel the grand shoba phone'  href='tel:+919874563210'> <button  className=" roompage-call-btn">Call Now</button></a>
                                 </div>
                                    <div className="col-12 col-md-auto">
                                    <Link title='v hotel the grand shoba related rooms' to="/related-room"> <button  className="roompage-query-btn">BOOK NOW</button></Link>
                                    </div>
                                </div>
          </div>
        </Col>
      </Row>
        </Container>
    </div>
    </div>



    <Testimonials/>

  
    </>
  )
}
